import type { FlatDownstreamData } from "@/Utils/downstreamHandlingUtils";
import { timezoneStore } from "@/api/hooks/useConfig";
import type { CardFilterTimeFrameIso } from "@/components/pageCards/filterSort/filterTimeFrame";
import type { WasteTypeConfig } from "@/pages/configuration/useConfigService";
import { REPORTING_TABLE_UNIT } from "@/pages/reporting_v2/types";

import ExcelJS from "exceljs";
import moment from "moment";

import type { TableRow, WasteColumn } from "../../../../types";

export type ReportingExportProps = {
  rows: TableRow[];
  totalsRow: TableRow;
  wasteColumns: WasteColumn[];
  unit: REPORTING_TABLE_UNIT;
  isIndividual: boolean;
  isPortfolio: boolean;
  showZones: boolean;
  nameLabel: string;
  title: string;
  selection: string;
  timeframe: CardFilterTimeFrameIso;
  wasteTypeConfig: WasteTypeConfig[];
  flatDownstreamData: FlatDownstreamData;
};

export const COL_WIDTH = 20;
export const ROW_HEIGHT = 25;
export const TOP_BORDER: Partial<ExcelJS.Borders> = {
  top: { style: "medium" },
};

export const FILE_NAME_KEYS: Record<REPORTING_TABLE_UNIT, string> = {
  [REPORTING_TABLE_UNIT.WEIGHT]: "exportLabels:reportingFileNameKg",
  [REPORTING_TABLE_UNIT.EMISSIONS]: "exportLabels:reportingFileNameCo2",
  [REPORTING_TABLE_UNIT.COST]: "exportLabels:reportingFileNameCost",
};

export const formatTimeframeDate = (iso: string | undefined, format: string) =>
  moment(iso || undefined)
    .tz(timezoneStore.getState().timezone)
    .format(format);

export const getPeriodExportLabel = (row: TableRow) =>
  [row.name, row.subLabel, row.dateRange && `(${row.dateRange})`]
    .filter(Boolean)
    .join(" ");

export const getDownstreamName = (
  column: WasteColumn,
  flatDownstreamData: FlatDownstreamData,
) =>
  column.downstreamHandlingId
    ? flatDownstreamData[column.downstreamHandlingId]?.name || ""
    : "";
